<template>
  <div v-if="instructor" class="instructor">
    <div class="instructor__avatar-container">
      <img
        v-tooltip="{
          content: `Show all content by<br/>${instructor.name}`,
          placement: 'top-center',
          classes: ['tooltip--text-center'],
        }"
        class="instructor__avatar"
        :src="$getInstructorImg(instructor.profile_img_url)"
        :alt="`INE Instructor ${instructor.name}`"
        @click="searchPresenter"
      />
    </div>
    <div class="instructor__info">
      <h5 class="instructor__name" itemprop="author">
        {{ instructor.name }}
      </h5>
      <div
        v-if="instructor.certifications.length"
        class="instructor__certifications"
      >
        <span>
          {{ certifications.join(', ') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Instructor',
  props: {
    instructor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    certifications() {
      const { certifications } = this.instructor
      return certifications.map(cert => cert.name)
    },
  },
  methods: {
    searchPresenter() {
      this.$store.dispatch('search/setQuery', '')
      this.$router.push({
        name: 'search',
        query: { 'instructors.name': this.instructor.name },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.instructor {
  $this: &;
  display: flex;
  gap: 30px;
  &__avatar {
    border-radius: 50%;
    width: inherit;

    &:hover {
      cursor: pointer;
    }
    &-container {
      width: 70px;
    }

    @include desktop {
      position: absolute;
      top: -80px;

      &-container {
        position: relative;
        width: 140px;
        flex: 0 0 140px;
      }
    }
  }
  &__name {
    margin: 0;
    color: var(--white);
    white-space: nowrap;
    font-family: var(--font-bold);
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.625rem;
  }
  &__certifications {
    margin-top: 5px;

    color: var(--dusty-gray);
    font-size: 0.75rem;
    line-height: 0.875rem;

    cursor: pointer;
  }
}
</style>
